import { useMemo } from "react";

import { useStaffRoles } from "../access/use-staff-roles";
import { type CatalogCapabilities, capabilitiesForRoles } from "./allowed-actions";

export function useCatalogCapabilities(): Readonly<{
  capabilities: CatalogCapabilities;
  isLoading: boolean;
}> {
  const { roles, isLoading } = useStaffRoles();
  const capabilities = useMemo(() => capabilitiesForRoles(roles), [roles]);
  return { capabilities, isLoading };
}
